import Vue from 'vue';

Vue.filter('localeDateTime', value => {
    if (value) {
        const date = new Date(value);
        return date.toLocaleString();
    }
    return '';
});
